module.exports = __webpack_public_path__ + "static/media/icon-quote.5cc8c979.svg";